module.exports = __webpack_public_path__ + "img/nevsBg.a9221ffd.png";